export const handleKeyDown = (event, callBack) => {
  const keyD = event.key !== undefined ? event.key : event.keyCode;
  if (keyD === 'Enter' || keyD === 13 || ['Spacebar', ' '].indexOf(keyD.toString()) >= 0 || keyD === 32) {
    // to prevent the page to scroll when "space" is pressed
    event.preventDefault();
    callBack === null || callBack === void 0 ? void 0 : callBack();
  }
};